var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4ab89a"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m5 19.0149v-4.2149h-3v-11.8h14v11.8h-6.78674zm-2-15.0149v9.8h3v2.8l2.79894-2.8h6.20106v-9.8z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 17.0406h5.8386l4.1666 4.1666v-4.0284h2.9948v-10.6788h-5v1h4v8.6788h-2.9948v2.6142l-2.7523-2.7524h-5.2529z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChat);
export default __webpack_public_path__ + "static/media/ico_chat.0d4ff158b1f0fd207bfac6184eb77cff.svg";
export { ForwardRef as ReactComponent };